/* Sklep 10 - logika sekcji pillar-* (bez zależności od skryptów Horizon) */
(function () {
  'use strict';
  var desktop = window.matchMedia('(min-width: 1024px)');

  /* ---------- G01: nagłówek ---------- */
  function initHeader(root) {
    if (root.dataset.pxReady) return;
    root.dataset.pxReady = '1';
    initCart(root);

    // kompaktowy stan po przewinięciu
    // Horizon przewija .page-wrapper zamiast okna - szukamy najbliższego przewijanego przodka
    var scroller = null;
    for (var el = root.parentElement; el && el !== document.body; el = el.parentElement) {
      var oy = getComputedStyle(el).overflowY;
      if (oy === 'auto' || oy === 'scroll') { scroller = el; break; }
    }
    function pos() { return scroller ? scroller.scrollTop : window.scrollY; }
    function room() {
      var sc = scroller || document.documentElement;
      return sc.scrollHeight - sc.clientHeight;
    }
    // histereza: zwinięcie nagłówka skraca stronę o ~100 px i przesuwa pozycję przewinięcia,
    // przy jednym progu klasa przełączała się w kółko (miganie). Dwa progi + krótka blokada po zmianie.
    var ticking = false, lockUntil = 0;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (Date.now() < lockUntil) return;
        var y = pos(), compact = root.classList.contains('is-compact');
        var next = compact ? y > 40 : (y > 220 && room() > 420);
        if (next !== compact) {
          root.classList.toggle('is-compact', next);
          lockUntil = Date.now() + 250;
        }
      });
    }
    (scroller || window).addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // szuflada menu (<dialog> daje Escape i blokadę tła; fokus wraca do przycisku)
    var drawer = root.querySelector('[data-px-drawer]');
    var burger = root.querySelector('[data-px-burger]');
    if (drawer && burger && typeof drawer.showModal === 'function') {
      burger.addEventListener('click', function () {
        drawer.showModal();
        burger.setAttribute('aria-expanded', 'true');
      });
      drawer.addEventListener('close', function () {
        burger.setAttribute('aria-expanded', 'false');
        burger.focus();
      });
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer || e.target.closest('[data-px-drawer-close]')) drawer.close();
      });
    }

    // rozwijane menu na desktopie: klik + Escape + wyjście fokusu
    root.querySelectorAll('[data-px-nav-item]').forEach(function (item) {
      var btn = item.querySelector('button');
      if (!btn) return;
      function setOpen(open) {
        if (open) item.setAttribute('data-open', ''); else item.removeAttribute('data-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      btn.addEventListener('click', function () { setOpen(!item.hasAttribute('data-open')); });
      item.addEventListener('mouseenter', function () { if (desktop.matches) setOpen(true); });
      item.addEventListener('mouseleave', function () { setOpen(false); });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && item.hasAttribute('data-open')) { setOpen(false); btn.focus(); }
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) setOpen(false);
      });
    });

    // wyszukiwarka: puste zapytanie nie wysyła formularza; kategoria -> filtry typu produktu
    root.querySelectorAll('[data-px-search]').forEach(function (form) {
      var select = form.querySelector('select');
      var input = form.querySelector('input[type="search"]');
      var hidden = form.querySelector('[data-px-search-filters]');
      form.addEventListener('submit', function (e) {
        if (!input.value.trim()) {
          e.preventDefault();
          input.focus();
          return;
        }
        if (!hidden) return;
        hidden.innerHTML = '';
        var opt = select && select.options[select.selectedIndex];
        var types = opt && opt.dataset.types ? opt.dataset.types.split('|') : [];
        types.forEach(function (t) {
          if (!t) return;
          var h = document.createElement('input');
          h.type = 'hidden';
          h.name = 'filter.p.product_type';
          h.value = t;
          hidden.appendChild(h);
        });
      });
      // na stronie wyników przywróć wybraną kategorię
      if (select) {
        var params = new URLSearchParams(window.location.search);
        var chosen = params.getAll('filter.p.product_type');
        if (chosen.length) {
          for (var i = 0; i < select.options.length; i++) {
            var list = (select.options[i].dataset.types || '').split('|');
            if (chosen.every(function (c) { return list.indexOf(c) !== -1; })) { select.selectedIndex = i; break; }
          }
        }
      }
    });
  }

  /* ---------- S03: zakładki (WAI-ARIA tabs) ---------- */
  function initTabs(root) {
    if (root.dataset.pxReady) return;
    root.dataset.pxReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') n = tabs[0];
        if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  }

  /* ---------- S04/S06: niezależne rzędy przewijane ---------- */
  function initRail(root) {
    if (root.dataset.pxReady) return;
    root.dataset.pxReady = '1';
    var rail = root.querySelector('[data-px-rail-track]');
    if (!rail) return;
    var prev = root.querySelector('[data-px-prev]');
    var next = root.querySelector('[data-px-next]');
    var bar = root.querySelector('[data-px-progress]');
    function step() {
      var item = rail.firstElementChild;
      if (!item) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      var perView = Math.max(1, Math.floor((rail.clientWidth + gap) / (item.getBoundingClientRect().width + gap)));
      return perView * (item.getBoundingClientRect().width + gap);
    }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      var canScroll = max > 2;
      if (prev) prev.disabled = !canScroll || rail.scrollLeft <= 2;
      if (next) next.disabled = !canScroll || rail.scrollLeft >= max - 2;
      if (prev && next) {
        var hide = !canScroll;
        prev.hidden = hide;
        next.hidden = hide;
      }
      if (bar) {
        var visible = rail.clientWidth / (rail.scrollWidth || 1);
        var pos = max > 0 ? rail.scrollLeft / max : 0;
        bar.style.width = (visible * 100) + '%';
        bar.style.transform = 'translateX(' + (pos * (1 / visible - 1) * 100) + '%)';
        if (bar.parentElement) bar.parentElement.hidden = !canScroll;
      }
    }
    function go(dir) {
      rail.scrollBy({ left: dir * step(), behavior: 'smooth' });
      setTimeout(update, 450); // zapas, gdyby zdarzenie scroll nie dotarło
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    rail.addEventListener('scroll', update, { passive: true });
    rail.addEventListener('scrollend', update);
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Koszyk: licznik w nagłówku i wysuwany panel koszyka motywu ---------- */
  var cartLink = null;
  var cartBound = false;
  function renderCartCount(count) {
    if (!cartLink) return;
    var badge = cartLink.querySelector('.px-cart-count');
    cartLink.setAttribute('aria-label', 'Koszyk, produktów: ' + count);
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'px-cart-count';
        badge.setAttribute('aria-hidden', 'true');
        cartLink.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }
  function refreshCartCount() {
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartCount(cart.item_count); })
      .catch(function () {});
  }
  function cartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    return drawer && typeof drawer.open === 'function' ? drawer : null;
  }
  function initCart(root) {
    cartLink = root.querySelector('.px-icon-link--cart');
    if (!cartLink) return;
    // ikona koszyka otwiera panel; na stronie koszyka i przy otwieraniu w nowej karcie zostaje zwykły link
    cartLink.addEventListener('click', function (e) {
      var drawer = cartDrawer();
      if (!drawer || e.metaKey || e.ctrlKey || e.shiftKey || /\/cart\/?$/.test(location.pathname)) return;
      e.preventDefault();
      drawer.open();
    });
    if (cartBound) return;
    cartBound = true;
    // zdarzenie motywu po każdej zmianie pozycji koszyka (strona produktu, pasek szybkiego dodawania, szybki podgląd)
    document.addEventListener('shopify:cart:lines-update', function (e) {
      var isAdd = e.action === 'add';
      var fromModal = e.target instanceof Element && e.target.closest('dialog[open]');
      var done = function (result) {
        refreshCartCount();
        var failed = result && result.detail && result.detail.didError;
        var drawer = cartDrawer();
        if (isAdd && !failed && !fromModal && drawer && !drawer.isOpen) drawer.open();
      };
      if (e.promise && typeof e.promise.then === 'function') e.promise.then(done, refreshCartCount);
      else setTimeout(done, 600);
    });
    // powrót z pamięci przeglądarki (np. z kasy) - licznik mógł się zmienić
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCartCount(); });
  }

  /* ---------- S07: galeria - przycisk pauzy ---------- */
  function initGallery(root) {
    if (root.dataset.pxReady) return;
    root.dataset.pxReady = '1';
    var btn = root.querySelector('[data-px-pause]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var paused = root.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.textContent = paused ? btn.dataset.labelPlay : btn.dataset.labelPause;
    });
  }

  /* ---------- F01: akordeony stopki tylko na telefonie ---------- */
  function initFooter(root) {
    var details = root.querySelectorAll('details[data-px-footer-group]');
    var tablet = window.matchMedia('(min-width: 768px)');
    function sync() { details.forEach(function (d) { d.open = tablet.matches; }); }
    if (!root.dataset.pxReady) {
      root.dataset.pxReady = '1';
      tablet.addEventListener('change', sync);
    }
    sync();
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-px-header]').forEach(initHeader);
    scope.querySelectorAll('[data-px-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-px-rail]').forEach(initRail);
    scope.querySelectorAll('[data-px-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-px-footer]').forEach(initFooter);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  // edytor motywu: ponowna inicjalizacja przeładowanej sekcji
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
